<template>
    <a-drawer :title="title" width="1200" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-row :gutter="10">
                <a-col :span="12">
                    <a-form-model-item label="课程名称" prop="name">
                        <a-input v-model="field.name" placeholder="请填写课程名称" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="课程类型" prop="type">
                        <a-select v-model="field.type" placeholder="请选择课程类型">
                            <template v-for="(val, key) in $enums.CourseType">
                                <a-select-option :value="key" :key="key">
                                    {{ val }}
                                </a-select-option>
                            </template>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="课程级别" prop="level">
                        <a-radio-group v-model="field.level" button-style="solid">
                            <template v-for="val in ['初级', '中级', '高级']">
                                <a-radio-button :value="val" :key="val">
                                    {{ val }}
                                </a-radio-button>
                            </template>
                        </a-radio-group>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="10">
                <a-col :span="6">
                    <a-form-model-item label="学习周期" prop="cycle">
                        <a-input v-model="field.cycle" placeholder="请填写学习周期" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="专业分类" prop="cata">
                        <a-input v-model="field.cata" placeholder="请填写专业分类" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="学时数" prop="hours">
                        <a-input-number v-model="field.hours" :min="1" :max="10000" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="是否线上学习" prop="online">
                        <a-switch v-model="field.online" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                    <a-form-model-item label="课程费用" prop="amt">
                        <a-input-number v-model="field.amt" :min="0" :max="1000000" :step="1.0" :precision="2" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="10">
                <a-col :span="12">
                    <a-form-model-item label="举办单位" prop="sponsor">
                        <a-input v-model="field.sponsor" placeholder="请填写举办单位" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="组织单位" prop="orgunit">
                        <a-input v-model="field.orgunit" placeholder="请填写组织单位" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="10">
                <a-col :span="12">
                    <a-form-model-item label="报名条件" prop="regq">
                        <a-textarea v-model="field.regq" placeholder="请填写报名条件" :auto-size="{ minRows: 3, maxRows: 3 }" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="课程详情" prop="info">
                        <a-textarea v-model="field.info" placeholder="请填写课程详情" :auto-size="{ minRows: 3, maxRows: 3 }" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="10">
                <a-col :span="6">
                    <a-form-model-item label="课程导师" prop="ctaid">
                        <a-select v-model="field.ctaid" placeholder="请选择课程导师">
                            <template v-for="cta in ctas">
                                <a-select-option :value="cta.id" :key="cta.id">
                                    {{ cta.name }}
                                </a-select-option>
                            </template>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="发放证书" prop="mcid">
                        <a-select mode="multiple" v-model="field.mcid" placeholder="请选择发放证书模板">
                            <template v-for="cert in certs">
                                <a-select-option :value="cert.id" :key="cert.id">
                                    {{ cert.name }}
                                </a-select-option>
                            </template>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="附加证书" prop="scid">
                        <a-select mode="multiple" v-model="field.scid" placeholder="请选择附加证书模板">
                            <template v-for="cert in certs">
                                <a-select-option :value="cert.id" :key="cert.id">
                                    {{ cert.name }}
                                </a-select-option>
                            </template>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-form-model-item label="课程图片" prop="imgs">
                <ImagesUpload type="CourseImg" v-if="init" :imgs.sync="field.imgs"></ImagesUpload>
            </a-form-model-item>
            <a-form-model-item label="通知书模板" prop="nct">
                <codemirror v-model="field.nct" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<style>
.CodeMirror {
    border: 1px solid #eee;
    height: auto;
    min-height: 300px;
    max-height: 300px;
}

.CodeMirror-scroll {
    height: auto;
    min-height: 300px;
    max-height: 300px;
    overflow-y: hidden;
    overflow-x: auto;
}
</style>

<script>
import ImagesUpload from '@/comp/ImagesUpload'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/xml/xml.js'

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    components: {
        ImagesUpload,
        codemirror
    },
    data() {
        return {
            init: false,
            field: {
                id: '',
                name: '',
                type: 'CT01',
                level: '初级',
                cycle: '',
                hours: 0,
                online: false,
                amt: '0.00',
                regq: '',
                sponsor: '',
                orgunit: '',
                info: '',
                video: '',
                imgs: '',
                cata: '',
                nct: '',
                ctaid: '',
                mcid: [],
                scid: []
            },
            rules: {
                name: [{ required: true, message: '请填写课程名称', trigger: 'blur' }],
                type: [{ required: true, message: '请选择课程类型', trigger: 'change' }],
                level: [{ required: true, message: '请选择课程级别', trigger: 'change' }],
                cycle: [{ required: true, message: '请填写学习周期', trigger: 'blur' }],
                hours: [{ required: true, message: '请填写学时数', trigger: 'blur' }],
                amt: [{ required: true, message: '请填写课程费用', trigger: 'blur' }],
                sponsor: [{ required: true, message: '请填写举办单位', trigger: 'blur' }],
                ctaid: [{ required: true, message: '请选择课程导师', trigger: 'change' }],
                online: [{ required: true, message: '请选择课程导师', trigger: 'change' }],
                mcid: [{ required: true, message: '请选择发放证书', trigger: 'change' }]
            },
            certs: [],
            ctas: [],
            fetching: false
        }
    },
    mounted() {
        if (this.item.id) {
            this.$http
                .get('/crs/train/course/detail', {
                    params: {
                        id: this.item.id
                    }
                })
                .then(result => {
                    this.detail = result.data
                    Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))
                    this.field.mcid = this.detail.certs.filter(c => c.main).map(c => c.id)
                    this.field.scid = this.detail.certs.filter(c => !c.main).map(c => c.id)
                    this.field.ctaid = this.detail.cta.id
                    this.init = true
                })
        } else {
            this.init = true
        }
        this.initData()
    },
    methods: {
        initData() {
            this.doLoadCertTmpl()
            this.doQueryCta('')
        },
        doLoadCertTmpl() {
            this.$http
                .get('/sys/data/crs/cert/tmpl', {
                    params: {
                        size: 10,
                        unit: false
                    },
                    loading: {
                        flag: false
                    }
                })
                .then(result => {
                    this.certs = result.datas
                })
        },
        doQueryCta(key) {
            this.fetching = true
            this.$http
                .get('/sys/data/user/cta', {
                    params: {
                        size: 100,
                        name: key,
                        sign: true
                    },
                    loading: {
                        flag: false
                    }
                })
                .then(result => {
                    this.ctas = result.datas
                    this.fetching = false
                })
        },
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.field.mcid = this.field.mcid.join()
                    this.field.scid = this.field.scid.join()
                    this.$http.post('/crs/train/course/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        } else {
                            this.field.mcid = this.field.mcid.split(',')
                            this.field.scid = this.field.scid.split(',')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))
                this.field.mcid = this.detail.certs.filter(c => c.main).map(c => c.id)
                this.field.scid = this.detail.certs.filter(c => !c.main).map(c => c.id)
                this.field.ctaid = this.detail.cta.id
            }
        }
    }
}
</script>
